import React from "react";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const PlayerViewSkeleton = () => {
  const deviceSize = useDeviceSize();
  return (
    <View
      style={{
        flexDirection: "row",
        gap:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 10
            : 20,
      }}
    >
      <View style={{ margin: 5, alignItems: "center" }}>
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 10
              : 30
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "100px"
              : "130px"
          }
          style={{
            borderRadius: 10,
          }}
        />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 10
              : 30
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "70px"
              : "100px"
          }
          style={{
            borderRadius: 10,
            marginTop: 10,
            marginBottom: 10,
          }}
        />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 140
              : 160
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "120px"
              : "130px"
          }
          style={{
            borderRadius: 10,
          }}
        />
      </View>
      <View style={{ marginBottom: 5, flexDirection: "column-reverse" }}>
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 80
              : 100
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "80px"
              : "100px"
          }
          style={{
            borderRadius: 10,
          }}
        />
      </View>
      <View style={{ margin: 5, alignItems: "center" }}>
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 10
              : 30
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "100px"
              : "130px"
          }
          style={{
            borderRadius: 10,
          }}
        />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 10
              : 30
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "70px"
              : "100px"
          }
          style={{
            borderRadius: 10,
            marginTop: 10,
            marginBottom: 10,
          }}
        />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 140
              : 160
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "120px"
              : "130px"
          }
          style={{
            borderRadius: 10,
          }}
        />
      </View>
    </View>
  );
};

export default PlayerViewSkeleton;
